import { createContext, useContext, useReducer, useEffect, JSX } from "react";
import { T_user } from "../common/model/user";

export type T_appState = {
  user?: T_user;
};

export type T_setAppState = (appState: T_appState) => void;

export const delAppState: T_appState = {

};

// localStorage에 저장된 값이 있으면 불러오고, 없으면 초기 상태를 사용합니다.
const savedAppState = localStorage.getItem("appState");
export const initialAppState: T_appState = savedAppState
  ? JSON.parse(savedAppState)
  : {};

const AppState = createContext({ appState: initialAppState, setAppState: (_:T_appState) => {} });

export function useAppState() {
  const { appState, setAppState } = useContext(AppState);
  return { appState, setAppState };
}

export type T_AppStateContextProps = {
  children: JSX.Element;
};

export const AppStateContext = ({ children }: T_AppStateContextProps) => {
  const [appState, setAppState] = useReducer(
    (prevAppState: T_appState, newAppState: T_appState) => newAppState,
    initialAppState
  );

  // 상태가 변경될 때마다 localStorage에 저장
  useEffect(() => {
    localStorage.setItem("appState", JSON.stringify(appState));
  }, [appState]);

  return (
    <AppState.Provider value={{ appState, setAppState }}>
      {children}
    </AppState.Provider>
  );
};
